export default "__VITE_ASSET__61155951__"